// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
                      .adf-toolbar-divider > div {
                        height: 24px;
                        width: 1px;
                        background: rgba(0, 0, 0, 0.26);
                        margin-left: 5px;
                        margin-right: 5px;
                      }
                    `, "",{"version":3,"sources":["webpack://./src/app/toolbar/toolbar-divider.component.ts"],"names":[],"mappings":";sBACsB;wBACE,YAAY;wBACZ,UAAU;wBACV,+BAA+B;wBAC/B,gBAAgB;wBAChB,iBAAiB;sBACnB","sourcesContent":["\n                      .adf-toolbar-divider > div {\n                        height: 24px;\n                        width: 1px;\n                        background: rgba(0, 0, 0, 0.26);\n                        margin-left: 5px;\n                        margin-right: 5px;\n                      }\n                    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
